// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locations__main {
  padding: 1%;
}
.locations__main .nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.locations__main .locations_top_section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.locations__main .locations_top_section h2 {
  font-size: 3rem;
}
.locations__main .locations_top_section h2 span {
  color: #e63b11;
}
.locations__main .locations_top_section h6 {
  font-weight: 400;
  font-size: 1.8rem;
  margin: 0 auto;
}
@media (min-width: 691px) and (max-width: 850px) {
  .locations__main .locations_top_section h2 {
    font-size: 2rem;
  }
  .locations__main .locations_top_section h6 {
    font-size: 1.2rem;
  }
}
@media (max-width: 690px) {
  .locations__main .locations_top_section {
    width: 90%;
    text-align: center;
  }
  .locations__main .locations_top_section h2 {
    font-size: 1.8rem;
  }
  .locations__main .locations_top_section h6 {
    font-size: 1.2rem;
  }
}
.locations__main .locations_data {
  background-color: #fafafa;
  display: flex;
  align-items: top;
  justify-content: space-around;
  padding-bottom: 2%;
  padding-top: 2%;
  margin-bottom: 2%;
}
.locations__main .locations_data .tableT {
  max-height: 62vh;
  text-align: center;
  overflow: auto;
  padding-left: 3%;
}
.locations__main .locations_data .tableT th {
  width: 400px;
}
.locations__main .locations_data #google-map {
  margin: 0 auto;
}
.locations__main .locations_data table thead {
  font-size: 1.5rem;
}
.locations__main .locations_data table tbody td {
  padding: 3%;
}
.locations__main .locations_data table tbody tr td {
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
}
.locations__main .locations_data #infoBox {
  border-radius: 20px;
  box-shadow: 2px 1px 9px -2px rgb(0, 0, 0);
  margin-left: -44%;
  width: 15%;
  height: 62vh;
  position: absolute;
  z-index: 10;
  background-color: white;
  color: #646464;
  padding: 0 0 2% 0;
}
.locations__main .locations_data #infoBox img {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 100%;
  height: 30%;
}
.locations__main .locations_data #infoBox .description {
  margin-left: 5%;
  margin-right: 5%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.locations__main .locations_data #infoBox .description h3 {
  color: #000;
}
.locations__main .locations_data #infoBox .description h3 span {
  color: #e63b11;
}
.locations__main .locations_data #infoBox .description div {
  overflow: auto;
  max-height: 15vh;
}
.locations__main .locations_data #infoBox .description div::-webkit-scrollbar {
  width: 15px;
}
.locations__main .locations_data #infoBox .description div::-webkit-scrollbar-track {
  background: #d1d3d4;
  border-radius: 20px;
}
.locations__main .locations_data #infoBox .description div::-webkit-scrollbar-thumb {
  background: #e63b11;
  border-radius: 20px;
}
.locations__main .locations_data #infoBox .description span {
  font-style: italic;
  font-weight: bold;
}
.locations__main .locations_data #infoBox .description p {
  font-size: 0.9rem;
}
.locations__main .locations_data #infoBox .description .directions {
  text-decoration: none;
  color: #000;
  border: 1px solid #d1d1d1;
  border-radius: 10px;
  padding: 3%;
}
.locations__main .locations_data #infoBox .description .directions:hover {
  background-color: #ffefef;
}
.locations__main .locations_data #infoBox .description #siteId {
  background-color: #e63b11;
  text-align: center;
  width: 90%;
  margin: 0 auto;
}
.locations__main .locations_data #infoBox .description #siteId span {
  color: white;
  letter-spacing: 1.2rem;
  font-style: normal;
  font-size: 1.5rem;
  padding-left: 1.2rem;
}
@media (max-width: 690px) {
  .locations__main .locations_data {
    display: block;
  }
  .locations__main .locations_data #google-map {
    min-height: 80vh;
    min-width: 95vw;
  }
  .locations__main .locations_data #infoBox {
    position: fixed;
    bottom: 3%;
    width: 90%;
    max-height: 75%;
    margin-left: 2%;
  }
  .locations__main .locations_data #infoBox .description {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .locations__main .locations_data #infoBox .description div {
    height: 60vh;
  }
  .locations__main .locations_data .tableT {
    display: none;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .locations__main .locations_data {
    display: block;
  }
  .locations__main .locations_data #infoBox {
    position: fixed;
    bottom: 3%;
    width: 50%;
    max-height: 55%;
    margin-left: 25%;
  }
  .locations__main .locations_data #google-map {
    min-height: 80vh;
    min-width: 95vw;
  }
  .locations__main .locations_data .tableT {
    display: none;
  }
  .locations__main .locations_data .description div {
    height: 22vh;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .locations__main .locations_data #infoBox {
    width: 29%;
    height: 83%;
    margin-left: -10%;
  }
  .locations__main .locations_data .description div {
    min-height: 30vh;
  }
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .locations__main .locations_data #infoBox {
    width: 20%;
    height: 67%;
    margin-left: -30%;
  }
  .locations__main .locations_data .description div {
    min-height: 28vh;
  }
}
@media (max-width: 690px) {
  .locations__main {
    padding: 3%;
  }
}
.locations__main .locator-main {
  height: auto;
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  margin: 0 10% 5% 10%;
}
@media (max-width: 850px) {
  .locations__main .locator-main {
    margin: 1%;
  }
}
.locations__main .searchStore {
  flex: 1 1;
  width: 100%;
  position: relative;
}
.locations__main .map {
  width: 100%;
  height: 100vh;
  position: sticky;
  top: 0;
}
.locations__main .mapContainer {
  flex: 1 1;
}
@media (max-width: 850px) {
  .locations__main .mapContainer {
    display: none;
  }
}
.locations__main .locaterFindHeading {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.locations__main .searchBtn {
  display: flex;
  padding-right: 20%;
  margin-top: 10px;
  margin-bottom: 20px;
  flex-direction: column;
  height: auto;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 99;
  border-bottom: 0.0625rem solid #e5e5e5;
  padding-bottom: 10px;
  padding-top: 10px;
}
@media (max-width: 850px) {
  .locations__main .searchBtn {
    padding-right: 0;
  }
}
.locations__main .findWIthLocation {
  margin-top: 10px;
}
.locations__main .EachStoreContainer {
  margin-top: 20px;
  margin-right: 50px;
  margin-bottom: 50px;
  border: 0.0625rem solid #e5e5e5;
  border-bottom: none;
}
@media (max-width: 850px) {
  .locations__main .EachStoreContainer {
    margin-right: 0;
  }
}
.locations__main .SingleStoreContainer {
  display: flex;
  flex-direction: row;
  border-bottom: 0.0625rem solid #e5e5e5;
}
.locations__main .SingleStoreContainer:hover {
  background-color: #f6f6f6;
}
.locations__main .location-details-main {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.locations__main .details-main {
  width: 70%;
}
.locations__main .store-details {
  margin-top: 30px;
}

iframe {
  width: 100%;
  height: 780px;
  border: 2px solid #e63b11;
}
@media (max-width: 690px) {
  iframe {
    height: 650px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/locator.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AADF;AAGE;EC2BE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AD3BJ;AACE;ECuBE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EDxBA,WAAA;AAIJ;AAFI;EACE,eAAA;AAIN;AAFM;EACE,cChBC;ADoBT;AAAI;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAEN;AACI;EACE;IACE,eAAA;EACN;EAEI;IACE,iBAAA;EAAN;AACF;AAGI;EA5BF;IA6BI,UAAA;IACA,kBAAA;EAAJ;EAEI;IACE,iBAAA;EAAN;EAGI;IACE,iBAAA;EADN;AACF;AAKE;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAII;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAFN;AAIM;EACE,YAAA;AAFR;AAMI;EACE,cAAA;AAJN;AAQM;EACE,iBAAA;AANR;AASM;EACE,WAAA;AAPR;AAYU;EACE,mBAAA;ECrBR,aAAA;EACA,mBAAA;EACA,8BAAA;EDqBQ,UAAA;AARZ;AAcI;EACE,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AAZN;AAaM;EACE,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,WAAA;AAXR;AAcM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;ECnFJ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ADwEJ;AAWQ;EACE,WAAA;AATV;AAWU;EACE,cCzHH;ADgHT;AAaQ;EACE,cAAA;EACA,gBAAA;AAXV;AAaU;EACE,WAAA;AAXZ;AAcU;EACE,mBCpIA;EDqIA,mBAAA;AAZZ;AAeU;EACE,mBC3IH;ED4IG,mBAAA;AAbZ;AAiBQ;EACE,kBAAA;EACA,iBAAA;AAfV;AAkBQ;EACE,iBAAA;AAhBV;AAmBQ;EACE,qBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAjBV;AAoBQ;EACE,yBAAA;AAlBV;AAqBQ;EACE,yBCtKD;EDuKC,kBAAA;EACA,UAAA;EACA,cAAA;AAnBV;AAsBQ;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AApBV;AAyBI;EApIF;IAqII,cAAA;EAtBJ;EAwBI;IACE,gBAAA;IACA,eAAA;EAtBN;EAyBI;IACE,eAAA;IACA,UAAA;IACA,UAAA;IACA,eAAA;IACA,eAAA;EAvBN;EAwBM;IChJJ,aAAA;IACA,mBAAA;IACA,6BAAA;ED2HF;EAqBQ;IACE,YAAA;EAnBV;EAwBI;IACE,aAAA;EAtBN;AACF;AAyBI;EA/JF;IAgKI,cAAA;EAtBJ;EAwBI;IACE,eAAA;IACA,UAAA;IACA,UAAA;IACA,eAAA;IACA,gBAAA;EAtBN;EAyBI;IACE,gBAAA;IACA,eAAA;EAvBN;EA0BI;IACE,aAAA;EAxBN;EA4BM;IACE,YAAA;EA1BR;AACF;AA8BI;EACE;IACE,UAAA;IACA,WAAA;IACA,iBAAA;EA5BN;EAgCM;IACE,gBAAA;EA9BR;AACF;AAkCI;EACE;IACE,UAAA;IACA,WAAA;IACA,iBAAA;EAhCN;EAoCM;IACE,gBAAA;EAlCR;AACF;AAuCE;EAxQF;IAyQI,WAAA;EApCF;AACF;AAsCE;EACE,YAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,oBAAA;AApCJ;AAqCI;EANF;IAOI,UAAA;EAlCJ;AACF;AAoCE;EACE,SAAA;EACA,WAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,MAAA;AAnCJ;AAsCE;EACE,SAAA;AApCJ;AAqCI;EAFF;IAGI,aAAA;EAlCJ;AACF;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAlCJ;AAoCE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sCAAA;EACA,oBAAA;EACA,iBAAA;AAlCJ;AAmCI;EAdF;IAeI,gBAAA;EAhCJ;AACF;AAkCE;EACE,gBAAA;AAhCJ;AAkCE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;AAhCJ;AAiCI;EANF;IAOI,eAAA;EA9BJ;AACF;AAgCE;EACE,aAAA;EACA,mBAAA;EACA,sCAAA;AA9BJ;AAgCE;EACE,yBAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AA/BJ;AAiCE;EACE,UAAA;AA/BJ;AAiCE;EACE,gBAAA;AA/BJ;;AAmCA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAhCF;AAiCE;EAJF;IAKI,aAAA;EA9BF;AACF","sourcesContent":["@import \"./variables.scss\";\n\n.locations__main {\n  padding: 1%;\n\n  .nav {\n    @include columnStartCenter;\n  }\n\n  .locations_top_section {\n    @include columnStartCenter;\n    width: 100%;\n\n    h2 {\n      font-size: 3rem;\n\n      span {\n        color: $orange;\n      }\n    }\n\n    h6 {\n      font-weight: 400;\n      font-size: 1.8rem;\n      margin: 0 auto;\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      h2 {\n        font-size: 2rem;\n      }\n\n      h6 {\n        font-size: 1.2rem;\n      }\n    }\n\n    @media (max-width: $mobile) {\n      width: 90%;\n      text-align: center;\n\n      h2 {\n        font-size: 1.8rem;\n      }\n\n      h6 {\n        font-size: 1.2rem;\n      }\n    }\n  }\n\n  .locations_data {\n    background-color: #fafafa;\n    display: flex;\n    align-items: top;\n    justify-content: space-around;\n    padding-bottom: 2%;\n    padding-top: 2%;\n    margin-bottom: 2%;\n    .tableT {\n      max-height: 62vh;\n      text-align: center;\n      overflow: auto;\n      padding-left: 3%;\n\n      th {\n        width: 400px;\n      }\n    }\n\n    #google-map {\n      margin: 0 auto;\n    }\n\n    table {\n      thead {\n        font-size: 1.5rem;\n      }\n\n      tbody td {\n        padding: 3%;\n      }\n\n      tbody {\n        tr {\n          td {\n            align-items: center;\n            @include rowBetween;\n            width: 90%;\n          }\n        }\n      }\n    }\n\n    #infoBox {\n      border-radius: 20px;\n      box-shadow: 2px 1px 9px -2px rgba(0, 0, 0, 1);\n      margin-left: -44%;\n      width: 15%;\n      height: 62vh;\n      position: absolute;\n      z-index: 10;\n      background-color: #ffff;\n      color: #646464;\n      padding: 0 0 2% 0;\n      img {\n        border-top-left-radius: 20px;\n        border-top-right-radius: 20px;\n        width: 100%;\n        height: 30%;\n      }\n\n      .description {\n        margin-left: 5%;\n        margin-right: 5%;\n        text-align: center;\n        @include columnStartCenter;\n\n        h3 {\n          color: #000;\n\n          span {\n            color: $orange;\n          }\n        }\n\n        div {\n          overflow: auto;\n          max-height: 15vh;\n\n          &::-webkit-scrollbar {\n            width: 15px;\n          }\n\n          &::-webkit-scrollbar-track {\n            background: $lightGrey;\n            border-radius: 20px;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background: $orange;\n            border-radius: 20px;\n          }\n        }\n\n        span {\n          font-style: italic;\n          font-weight: bold;\n        }\n\n        p {\n          font-size: 0.9rem;\n        }\n\n        .directions {\n          text-decoration: none;\n          color: #000;\n          border: 1px solid #d1d1d1;\n          border-radius: 10px;\n          padding: 3%;\n        }\n\n        .directions:hover {\n          background-color: #ffefef;\n        }\n\n        #siteId {\n          background-color: $orange;\n          text-align: center;\n          width: 90%;\n          margin: 0 auto;\n        }\n\n        #siteId span {\n          color: #ffff;\n          letter-spacing: 1.2rem;\n          font-style: normal;\n          font-size: 1.5rem;\n          padding-left: 1.2rem;\n        }\n      }\n    }\n\n    @media (max-width: $mobile) {\n      display: block;\n\n      #google-map {\n        min-height: 80vh;\n        min-width: 95vw;\n      }\n\n      #infoBox {\n        position: fixed;\n        bottom: 3%;\n        width: 90%;\n        max-height: 75%;\n        margin-left: 2%;\n        .description {\n          @include rowEven;\n          div {\n            height: 60vh;\n          }\n        }\n      }\n\n      .tableT {\n        display: none;\n      }\n    }\n\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n      display: block;\n\n      #infoBox {\n        position: fixed;\n        bottom: 3%;\n        width: 50%;\n        max-height: 55%;\n        margin-left: 25%;\n      }\n\n      #google-map {\n        min-height: 80vh;\n        min-width: 95vw;\n      }\n\n      .tableT {\n        display: none;\n      }\n\n      .description {\n        div {\n          height: 22vh;\n        }\n      }\n    }\n\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n      #infoBox {\n        width: 29%;\n        height: 83%;\n        margin-left: -10%;\n      }\n\n      .description {\n        div {\n          min-height: 30vh;\n        }\n      }\n    }\n\n    @media (min-width: $smallScreen) and (max-width: $regularScreen) {\n      #infoBox {\n        width: 20%;\n        height: 67%;\n        margin-left: -30%;\n      }\n\n      .description {\n        div {\n          min-height: 28vh;\n        }\n      }\n    }\n  }\n\n  @media (max-width: $mobile) {\n    padding: 3%;\n  }\n\n  .locator-main {\n    height: auto;\n    display: flex;\n    flex: 1;\n    justify-content: space-between;\n    margin: 0 10% 5% 10%;\n    @media (max-width: $tabletMax) {\n      margin: 1%;\n    }\n  }\n  .searchStore {\n    flex: 1;\n    width: 100%;\n    position: relative;\n  }\n\n  .map {\n    width: 100%;\n    height: 100vh;\n    position: sticky;\n    top: 0;\n  }\n\n  .mapContainer {\n    flex: 1;\n    @media (max-width: $tabletMax) {\n      display: none;\n    }\n  }\n  .locaterFindHeading {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n  }\n  .searchBtn {\n    display: flex;\n    padding-right: 20%;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    flex-direction: column;\n    height: auto;\n    background-color: #ffffff;\n    position: sticky;\n    top: 0;\n    z-index: 99;\n    border-bottom: 0.0625rem solid #e5e5e5;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    @media (max-width: $tabletMax) {\n      padding-right: 0;\n    }\n  }\n  .findWIthLocation {\n    margin-top: 10px;\n  }\n  .EachStoreContainer {\n    margin-top: 20px;\n    margin-right: 50px;\n    margin-bottom: 50px;\n    border: 0.0625rem solid #e5e5e5;\n    border-bottom: none;\n    @media (max-width: $tabletMax) {\n      margin-right: 0;\n    }\n  }\n  .SingleStoreContainer {\n    display: flex;\n    flex-direction: row;\n    border-bottom: 0.0625rem solid #e5e5e5;\n  }\n  .SingleStoreContainer:hover {\n    background-color: #f6f6f6;\n  }\n\n  .location-details-main {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n  .details-main {\n    width: 70%;\n  }\n  .store-details {\n    margin-top: 30px;\n  }\n}\n\niframe {\n  width: 100%;\n  height: 780px;\n  border: 2px solid $orange;\n  @media (max-width: $mobile) {\n    height: 650px;\n  }\n}\n","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
